import { Language } from "../language.model"
import {
    AudioMedia,
    DocumentMedia,
    HTMLFragmentMedia,
    ImageMedia,
    GenericInteractiveMedia,
    LTIMedia,
    Media,
    VideoMedia,
} from "./media"

export class Asset {
    /*
    Business constraint: All medias in the asset are of the same type which also matches self.mediaType.
    Has state.
    It contains the currently selected media.
    Each media is specific to a language.
     */
    public selectedMedia: Media

    constructor(
        public guid: string = "",
        public title: string = "",
        public mediaType: string = "",
        public medias: Media[] = [],
        public description: string = "",
        public isDownloadable: boolean = false,
        public permittedUse: string = "",
        public accessibility: string[] = []
    ) {
        if (this.medias && this.medias.length) {
            this.selectedMedia = this.medias[0]
        }
    }

    public selectLanguage(language: Language = null) {
        if (!language) {
            this.selectedMedia = this.medias[0]
        } else {
            this.selectedMedia = this.medias.find(
                (media: Media) => media.language === language
            )
        }
    }

    public getSelectedMediaLanguage(): Language {
        if (this.selectedMedia) {
            return this.selectedMedia.language
        } else {
            return null
        }
    }

    public getRemainingMedias(): Media[] {
        return this.medias.filter(
            (media) => media.language !== this.selectedMedia.language
        )
    }

    public getDefaultPosterImage(): string {
        return this.selectedMedia.getDefaultPosterImage()
    }

    public static fromData(data) {
        const medias = (data.medias || []).map((media) => Media.fromData(media))
        return new Asset(
            data.guid,
            data.title,
            data.media_type,
            medias,
            data.description,
            data.is_downloadable,
            data.use_rights,
            data.accessibility_indicators || []
        )
    }

    public isDocument() {
        return this.selectedMedia instanceof DocumentMedia
    }

    public isVideo() {
        return this.selectedMedia instanceof VideoMedia
    }

    public isAudio() {
        return this.selectedMedia instanceof AudioMedia
    }

    public isImage() {
        return this.selectedMedia instanceof ImageMedia
    }

    public isLTI() {
        return this.selectedMedia instanceof LTIMedia
    }

    public isGenericInteractive() {
        return this.selectedMedia instanceof GenericInteractiveMedia
    }

    public isHTMLFragment() {
        return this.selectedMedia instanceof HTMLFragmentMedia
    }
}
